import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import counter from './counter';
import history from '../../lib/history';
import { enableES5 } from 'immer';
import initApp from './initApp';
import raiseQuery from './raiseQuery';
import authenticateReducer from './authenticate';
import addUser from './addUser';
import pmsUser from './pmsReducer';
import aifLogin from './aifLogin';
import reports from './reports';
import ditUserToken from './ditUserToken';
import ditReport from './ditReport';
import responseError from './responseError';

enableES5();
let historyR = !process.env.IS_SERVER ? { router: connectRouter(history) } : {};

export default combineReducers({
  counter,
  ...historyR,
  initApp,
  raiseQuery,
  addUser,
  authenticateUser: authenticateReducer,
  pmsUser,
  aifLogin,
  reports,
  ditUserToken,
  ditReport,
  responseError
})
